import React from 'react';
import PresentationRow from './PresentationRow';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';

import AddIcon from '@material-ui/icons/AddCircle';

import Dialog from './Dialog';

export default class PresentationsTable extends React.Component {
    state = {
        data: [],
        open: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.data !== state.data) {
            state.data = props.data ? props.data : [];
            return state;
        }
        return null;
    }

    handleRowDel = (row) => {
        const { data } = this.state.data;
        var index = data.indexOf(row);
        data.splice(index, 1);
        const event = {
            target: {
                name: 'presentaciones',
                value: data,
            },
        };
        this.setState({ data: data });
        this.props.onChange(event);
    };

    handleAddEvent = () => {
        var row = {
            id: randomstring(),
            nombre: '',
        };
        this.setState({ open: row });
    };

    handleUpdateTable = (row) => {
        this.setState({ open: row });
    };

    handleClose = (row) => {
        if (row) {
            const arr = [...this.state.data];
            const index = arr.map((i) => i.id).indexOf(row.id);

            if (index >= 0) {
                arr[index] = row;
            } else {
                arr.push(row);
            }

            const event = {
                target: {
                    name: 'presentaciones',
                    value: arr,
                },
            };
            this.setState({ data: arr, open: undefined });
            this.props.onChange(event);
        } else {
            this.setState({ open: undefined });
        }
    };

    render() {
        const { data, open } = this.state;
        const updaterow = this.handleUpdateTable;
        const delrow = this.handleRowDel;

        return (
            <div className={'container-table100 flex_full_column'}>
                <div className="flex_full_row align_center padding_bottom_24 width100">
                    <div className={'barlow_medium_italic c_slate_grey flex_full_row'}>
                        <FormattedMessage id="form_field_name_presentations" />
                    </div>
                    <AddIcon
                        className={'c_bluish hand'}
                        fontSize="large"
                        onClick={this.handleAddEvent}
                    />
                </div>
                <section className="flex_full_column table100">
                    <header className="flex_auto_row">
                        <div className="col">
                            <FormattedMessage id="form_field_name_nombre" />
                        </div>
                        <div className="" />
                    </header>
                    <div className="flex_full_column tbody">
                        {data &&
                            data
                                .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                                .map(function (row, index) {
                                    return (
                                        <PresentationRow
                                            data={row}
                                            key={randomstring()}
                                            id={index}
                                            onDelEvent={delrow}
                                            onEditEvent={updaterow}
                                        />
                                    );
                                })}
                    </div>
                </section>
                {open && <Dialog {...this.props} value={open} onClose={this.handleClose} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/complex/manage/reference/PresentationTable.js